import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterSortDirectionLogic} from "./FilterSortDirection.logic";
import {RadioButtonFilterGroup} from "../../filters/radio-button-filter-group/RadioButtonFilterGroup";
import {MySongsPageSortDirectionType} from "../../../config/my-songs-page-sort";
import s from "./FilterSortDirection.module.scss";

export const FilterSortDirection: VoidFunctionComponent = () => {
  const {value, options, onChangeHandler} = useFilterSortDirectionLogic();

  if (options.length < 2) { // No choice - only one option.
    return null;
  }

  return (
    <div className={s.container}>
      <p className={s.groupLabel}>Sorting Order</p>
      <RadioButtonFilterGroup<MySongsPageSortDirectionType>
        value={value}
        onChange={onChangeHandler}
        options={options}
      />
    </div>
  );
}
